import React, { useEffect, useState } from 'react';
import { LeadFunnel } from './components/funnel/LeadFunnel';

function App() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Small delay to ensure all assets are rendered and then remove splash
    const timer = setTimeout(() => {
      document.body.classList.add('app-ready');
      setIsLoaded(true);
    }, 800);

    return () => clearTimeout(timer);
  }, []);

  if (!isLoaded) return null;

  return (
    <LeadFunnel />
  );
}

export default App;